export default class HomeSearch {
  constructor() {
    if (!this.vars()) return false;
    this.setupEvents();
  }

  vars() {
    this.selectors = {
      citiesJson: 'data-json-cities',
      subjectsJson: 'data-json-subjects',
      input: 'data-search-input',
      searchWrapper: 'data-search-wrapper',
      searchWrapperActive: 'kv__searchWrapper--active',
      resultsList: 'kv__resultsList',
      cityInput: 'data-form-city',
      subjectInput: 'data-form-subject',
      form: 'data-search-form',
    };

    this.list = '';
    this.results = null;
    this.resultsToDisplay = 5;

    const citiesJsonEl = document.querySelector(`[${this.selectors.citiesJson}]`);
    const subjectsJsonEl = document.querySelector(`[${this.selectors.subjectsJson}]`);
    this.input = document.querySelector(`[${this.selectors.input}]`);
    this.searchWrapper = document.querySelector(`[${this.selectors.searchWrapper}]`);
    this.resultsList = document.querySelector(`.${this.selectors.resultsList}`);
    this.cityInput = document.querySelector(`[${this.selectors.cityInput}]`);
    this.subjectInput = document.querySelector(`[${this.selectors.subjectInput}]`);
    this.form = document.querySelector(`[${this.selectors.form}]`);

    if (!citiesJsonEl || !subjectsJsonEl || !this.input || !this.searchWrapper || !this.resultsList || !this.cityInput || !this.subjectInput || !this.form) {
      return false;
    }

    const cities = citiesJsonEl.value;
    const subjects = subjectsJsonEl.value;

    if (!cities || !subjects) return false;

    this.cities = JSON.parse(cities);
    this.subjects = JSON.parse(subjects);

    if (!this.cities || !this.subjects) return false;

    this.showNoResults();

    return true;
  }

  setupEvents() {
    this.input.addEventListener('input', () => {
      this.search(this.input.value);
    });

    this.input.addEventListener('focus', () => {
      this.searchWrapper.classList.add(this.selectors.searchWrapperActive);
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.kv__searchWrapper')) {
        this.searchWrapper.classList.remove(this.selectors.searchWrapperActive);
        // this.useFirstItem();
      }
    });

    this.form.addEventListener('submit', (event) => {
      this.useFirstItem();
    });
  }

  search(text) {
    this.results = null;

    if (!this.input.value.length) {
      this.showNoResults();
      return false;
    }

    const commaSplit = text.split(',');
    const spaceSplit = text.split(' ');

    let cityResults = [];
    let subjectResults = [];

    commaSplit.forEach((subText) => {
      if (subText.length) {
        cityResults = [...cityResults, ...this.searchCity(subText)];
        subjectResults = [...subjectResults, ...this.searchSubject(subText)];
      }
    });

    spaceSplit.forEach((subText) => {
      if (subText.length) {
        cityResults = [...cityResults, ...this.searchCity(subText)];
        subjectResults = [...subjectResults, ...this.searchSubject(subText)];
      }
    });

    this.results = {
      cities: this.removeDuplicates(cityResults).slice(0, this.resultsToDisplay - 1),
      subjects: this.removeDuplicates(subjectResults).slice(0, this.resultsToDisplay - 1),
    };

    this.showResults();
  }

  removeDuplicates(collection) {
    return collection.reduce((filtered, item) => {
      if (!filtered.some(filteredItem => JSON.stringify(filteredItem) == JSON.stringify(item))) {
        filtered.push(item);
      }
      return filtered;
    }, []);
  }

  searchCity(text) {
    return this.cities.filter((item) => {
      return item.name.search(new RegExp(`^${text}[a-zA-ZęóąśłżźćńĘÓĄŚŁŻŹĆŃ]*`, 'i')) !== -1 ? item : false;
    });
  }

  searchSubject(text) {
    return this.subjects.filter((item) => {
      return item.name.search(new RegExp(text, 'i')) !== -1 ? item : false;
    });
  }

  createItem(text, citySlug, subjectSlug, noResults = false) {
    return `<li class="kv__resultsItem" data-no-results="${noResults}" data-city-slug="${citySlug || ''}" data-subject-slug="${subjectSlug || ''}">${text}</li>`;
  }

  showNoResults() {
    this.clearList();
    this.resultsList.innerHTML = this.createItem('Brak wyników', null, null, true);
  }

  clearList() {
    this.list = '';
    this.resultsList.innerHTML = '';
  }

  showResults() {
    this.clearList();
    const items = [];

    if (this.results.cities.length && !this.results.subjects.length) {
      this.results.cities.forEach((city) => items.push({
        multiple: false,
        city: city,
        subject: null,
      }));
    } else if (!this.results.cities.length && this.results.subjects.length) {
      this.results.subjects.forEach((subject) => items.push({
        multiple: false,
        city: null,
        subject: subject,
      }));
    } else if (this.results.cities.length && this.results.subjects.length) {
      this.results.cities.forEach((city) => {
        this.results.subjects.forEach((subject) => {
          items.push({
            multiple: true,
            city: city,
            subject: subject,
          });
        });
      });
      this.results.subjects.forEach((subject) => items.push(subject));
    }

    if (!items.length) {
      this.showNoResults();
      return false;
    }

    items.forEach((item) => {
      if (item.multiple) {
        this.list += this.createItem(`${item.subject.name} - ${item.city.name}`, item.city.slug, item.subject.slug);
      } else if (item.city) {
        this.list += this.createItem(item.city.name, item.city.slug, null);
      } else if (item.subject) {
        this.list += this.createItem(item.subject.name, null, item.subject.slug);
      }
    });

    this.resultsList.innerHTML = this.list;
    this.addListEvents();
  }

  addListEvents() {
    const items = Array.from(this.resultsList.querySelectorAll('li'));
    items.forEach((item) => {
      item.addEventListener('click', () => {
        this.setupItem(item);
      });
    });
  }

  setupItem(item) {
    if (!item || item.getAttribute('data-no-results') == 'true') return false;
    this.input.value = item.innerText;
    this.cityInput.value = item.getAttribute('data-city-slug');
    this.subjectInput.value = item.getAttribute('data-subject-slug');
    this.searchWrapper.classList.remove(this.selectors.searchWrapperActive);
  }

  useFirstItem() {
    if (!this.cityInput.value && !this.subjectInput.value) {
      const items = Array.from(this.resultsList.querySelectorAll('li'));
      this.setupItem(items[0]);
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Components/HomeSearch.js